<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Import Modal (ตาม wireframe §1.2 — Import อยู่หน้า Add) -->
      <div
        class="modal fade"
        id="importStockCoverDaysModal"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Import ข้อมูลตามเป้าหมาย</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form ref="importForm">
                <div class="form-group">
                  <label>ไฟล์ Excel (.xlsx) <span class="text-danger">*</span></label>
                  <div class="custom-file">
                    <input
                      type="file"
                      class="custom-file-input"
                      id="importFile"
                      accept=".xlsx"
                      @change="onFileChange"
                      ref="importFileInput"
                    />
                    <label class="custom-file-label" for="importFile">
                      {{ importFileName || 'เลือกไฟล์...' }}
                    </label>
                  </div>
                  <small class="form-text text-muted">รองรับไฟล์ .xlsx เท่านั้น</small>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">ยกเลิก</button>
              <button
                type="button"
                class="btn btn-primary"
                @click="submitImport"
                :disabled="!importFile"
              >
                <i class="fas fa-upload"></i> นำเข้าข้อมูล
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- end: Import Modal -->

      <div class="kt-portlet kt-portlet--mobile">
        <!-- Header -->
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fas fa-plus-circle"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              เพิ่มข้อมูล Stock Cover Days
            </h3>
          </div>
          <div class="kt-portlet__head-toolbar">
            <button type="button" class="btn btn-info kt-margin-r-10" @click="downloadTemplate">
              <i class="fas fa-download"></i> Download Template
            </button>
            <button type="button" class="btn btn-success" @click="showImportModal">
              <i class="fas fa-file-import"></i> Import ข้อมูลตามเป้าหมาย
            </button>
          </div>
        </div>

        <div class="kt-portlet__body">
          <!--
            IssueList #18 (Major redesign, folds in #17/#16/#15b):
            FLAT inline-edit grid — every row is a COMPLETE record (Month, Year, SaleDays,
            Plant, Product, BG, Demand, Supply) — the exact Import-template shape. No page-header
            plant/year snapshot anymore. "บันทึก" routes rows through the SAME Import-confirm
            pipeline (/ImportConfirm) that enforces C1 uniform-sale-days + per-(plant,product,year)
            versioning — NOT the old header-based /Save.
          -->
          <form
            ref="scvdForm"
            id="scvdCreateForm"
            class="kt-form"
            autocomplete="off"
            @submit.prevent="onSubmit"
          >
            <!-- R2-6: overflow-x เพื่อ scrollbar แนวนอนเมื่อจอแคบกว่าความกว้างตาราง (min-width px) -->
            <div class="table-responsive" style="overflow-x: auto;">
              <!-- R2-6: table-layout:fixed + min-width(px) → คอลัมน์กว้างคงที่ (px) ไม่ขยับตาม content · รวม 1535px -->
              <table class="table table-bordered table-sm table-hover scvd-flat-grid" style="table-layout: fixed; min-width: 1555px;">
                <thead class="thead-light">
                  <tr>
                    <!-- R2-6: ความกว้างคอลัมน์เป็น px คงที่ — table-layout:fixed จึงไม่ขยับตาม content · รวม 1535px -->
                    <!-- (จอเล็ก = min-width px เป๊ะ → เดือน/ปี + ชื่อคลัง/ชื่อสินค้า ต้องกว้างพอไม่ให้ชื่อถูกบีบ) -->
                    <th style="width: 56px;" class="text-center">ลำดับ</th>
                    <th style="width: 115px;" class="text-center">เดือน <span class="text-danger">*</span></th>
                    <th style="width: 110px;" class="text-center">ปี <span class="text-danger">*</span></th>
                    <th style="width: 98px;" class="text-center">จำนวนวันขาย<br />(วัน) <span class="text-danger">*</span></th>
                    <!-- R2-5: rename หัวคอลัมน์ code → ชื่อ + ตัดคอลัมน์ display ชื่อ (ซ้ำ) ออก (select2 แสดงชื่อเต็มอยู่แล้ว) -->
                    <th style="width: 350px;" class="text-center">ชื่อคลังสินค้า <span class="text-danger">*</span></th>
                    <th style="width: 350px;" class="text-center">ชื่อสินค้า <span class="text-danger">*</span></th>
                    <th style="width: 112px;" class="text-center">จำนวน BG Stock(ลิตร) <span class="text-danger">*</span></th>
                    <th style="width: 112px;" class="text-center">จำนวน Demand(ลิตร) <span class="text-danger">*</span></th>
                    <th style="width: 112px;" class="text-center">จำนวน Supply(ลิตร) <span class="text-danger">*</span></th>
                    <th style="width: 70px;" class="text-center">SCVD</th>
                    <th style="width: 70px;" class="text-center">คำสั่ง</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="rows.length === 0">
                    <td colspan="11" class="text-center text-muted">
                      ยังไม่มีรายการ คลิก "เพิ่มข้อมูลตามเป้าหมาย" เพื่อเพิ่ม
                    </td>
                  </tr>
                  <tr
                    v-for="(row, i) in rows"
                    :key="'scvd-' + row._uid"
                    :class="{ 'table-danger': row._hasError }"
                  >
                    <td class="text-center align-middle">{{ i + 1 }}</td>

                    <!-- Month (1..12) -->
                    <td>
                      <select
                        class="form-control form-control-sm"
                        v-model="row.month"
                        :name="'month_' + row._uid"
                        required
                        data-msg-required="กรุณาเลือกเดือน"
                      >
                        <option value="">-- เลือก --</option>
                        <option v-for="m in monthOptions" :key="m.value" :value="m.value">
                          {{ m.text }}
                        </option>
                      </select>
                    </td>

                    <!-- Year (R2-1: {cur-1, cur, cur+1} — backdate 1 yr allowed per spec B31) -->
                    <td>
                      <select
                        class="form-control form-control-sm"
                        v-model.number="row.year"
                        :name="'year_' + row._uid"
                        required
                        data-msg-required="กรุณาเลือกปี"
                      >
                        <option v-for="y in yearOptions" :key="y" :value="y">{{ y }}</option>
                      </select>
                    </td>

                    <!-- จำนวนวันขาย(วัน) -->
                    <td>
                      <input
                        type="text"
                        inputmode="numeric"
                        class="form-control form-control-sm text-right"
                        v-model="row.saleDays"
                        :name="'saleDays_' + row._uid"
                        required
                        data-msg-required="กรุณากรอกจำนวนวันขาย"
                        @keydown="onIntKeydown($event)"
                        @blur="onSaleDaysBlur(row, $event)"
                      />
                    </td>

                    <!-- ชื่อคลังสินค้า (Select2 → plantCode; select2 แสดงชื่อเต็ม) · R2-5: ตัด display column "ชื่อคลังสินค้า" (ซ้ำ) ออก · row.plantName ยัง auto-fill สำหรับ payload -->
                    <td>
                      <select2
                        :css-style="'width: 100%;'"
                        :css-class="'form-control form-control-sm'"
                        :id="'plantSel_' + row._uid"
                        :name="'plantSel_' + row._uid"
                        :ref-obj="row._uid"
                        :select2-options="plantOptions"
                        v-model="row.plantCode"
                        @selectChange="onPlantChange"
                      ></select2>
                    </td>

                    <!-- ชื่อสินค้า (Select2 → productCode; select2 แสดงชื่อเต็ม) · R2-5: ตัด display column "ชื่อสินค้า" (ซ้ำ) ออก · row.productName ยัง auto-fill สำหรับ payload -->
                    <td>
                      <select2
                        :css-style="'width: 100%;'"
                        :css-class="'form-control form-control-sm'"
                        :id="'prodSel_' + row._uid"
                        :name="'prodSel_' + row._uid"
                        :ref-obj="row._uid"
                        :select2-options="productOptions"
                        v-model="row.productCode"
                        @selectChange="onProductChange"
                      ></select2>
                    </td>

                    <!-- จำนวน BG Stock(ลิตร) — thousands-format on blur, strip on focus -->
                    <td>
                      <input
                        type="text"
                        inputmode="numeric"
                        class="form-control form-control-sm text-right"
                        v-model="row.bgStockText"
                        :name="'bg_' + row._uid"
                        required
                        data-msg-required="กรุณากรอกจำนวน BG Stock"
                        @keydown="onIntKeydown($event)"
                        @focus="onNumFocus(row, 'bgStock')"
                        @blur="onNumBlur(row, 'bgStock')"
                      />
                    </td>

                    <!-- จำนวน Demand(ลิตร) -->
                    <td>
                      <input
                        type="text"
                        inputmode="numeric"
                        class="form-control form-control-sm text-right"
                        v-model="row.demandText"
                        :name="'demand_' + row._uid"
                        required
                        data-msg-required="กรุณากรอกจำนวน Demand"
                        @keydown="onIntKeydown($event)"
                        @focus="onNumFocus(row, 'demand')"
                        @blur="onNumBlur(row, 'demand')"
                      />
                    </td>

                    <!-- จำนวน Supply(ลิตร) -->
                    <td>
                      <input
                        type="text"
                        inputmode="numeric"
                        class="form-control form-control-sm text-right"
                        v-model="row.supplyText"
                        :name="'supply_' + row._uid"
                        required
                        data-msg-required="กรุณากรอกจำนวน Supply"
                        @keydown="onIntKeydown($event)"
                        @focus="onNumFocus(row, 'supply')"
                        @blur="onNumBlur(row, 'supply')"
                      />
                    </td>

                    <!-- SCVD (read-only computed cell — same formula as display pages) -->
                    <td class="text-right align-middle font-weight-bold">
                      {{ formatScvd(row.scvd) }}
                    </td>

                    <!-- คำสั่ง -->
                    <td class="text-center align-middle">
                      <button
                        type="button"
                        class="btn btn-sm btn-clean btn-icon btn-icon-md"
                        title="ลบรายการ"
                        @click="removeRow(i)"
                      >
                        <i class="la la-trash text-danger"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <small class="text-muted">* SCVD คำนวณอัตโนมัติ (ปัดเศษ 2 ตำแหน่ง) — แสดง "-" เมื่อจำนวนวันขาย หรือ Demand เป็น 0</small>

            <!-- เพิ่มข้อมูลตามเป้าหมาย (appends a blank editable row) -->
            <div class="row mt-3">
              <div class="col-12">
                <button type="button" class="btn btn-primary" @click="addRow">
                  <i class="la la-plus"></i> เพิ่มข้อมูลตามเป้าหมาย
                </button>
              </div>
            </div>

            <!-- Footer action bar — ย้อนกลับ (la la-close) LEFT · บันทึก FAR RIGHT -->
            <div class="row mt-4">
              <div class="col-12">
                <hr />
                <div class="d-flex justify-content-between">
                  <button type="button" class="btn btn-secondary" @click="goBack">
                    <i class="la la-close"></i> ย้อนกลับ
                  </button>
                  <button
                    type="submit"
                    class="btn btn-primary"
                    :disabled="isSaving"
                  >
                    <i class="la la-save"></i> {{ isSaving ? 'กำลังบันทึก...' : 'บันทึก' }}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../Shared/Select2";

require("sweetalert2");

export default {
  components: {
    select2,
  },
  data: function () {
    var self = this;
    var currentYear = new Date().getFullYear();
    var authTransport = function (params, success, failure) {
      params.beforeSend = function (request) {
        request.setRequestHeader(
          "Authorization",
          "Bearer " + self.$root.user.access_token
        );
      };
      var $request = $.ajax(params);
      $request.then(success);
      $request.fail(failure);
      return $request;
    };

    return {
      isSaving: false,
      uidCounter: 1,
      rows: [], // seeded with one empty row in created()
      currentYear: currentYear,

      // Import (ตาม wireframe §1.2 — Import + Download Template อยู่หน้า Add)
      importFile: null,
      importFileName: "",
      lastImportRows: null,

      // เดือน (value = 1..12) — แสดง label เป็นตัวย่อ JAN–DEC ให้ตรงกับ Template/Import (#18 verify)
      monthOptions: [
        { value: 1, text: "JAN" },
        { value: 2, text: "FEB" },
        { value: 3, text: "MAR" },
        { value: 4, text: "APR" },
        { value: 5, text: "MAY" },
        { value: 6, text: "JUN" },
        { value: 7, text: "JUL" },
        { value: 8, text: "AUG" },
        { value: 9, text: "SEP" },
        { value: 10, text: "OCT" },
        { value: 11, text: "NOV" },
        { value: 12, text: "DEC" },
      ],

      // R2-1 (spec B31): ย้อนหลัง 1 ปี + ปัจจุบัน + ล่วงหน้า 1 ปี = {cur-1, cur, cur+1} เรียงมาก→น้อย.
      // create/import ย้อนหลังได้ 1 ปี (กฎแก้ไขคงเดิม: ปีเก่า read-only). ตรงกับ BE import year-validate.
      yearOptions: [currentYear + 1, currentYear, currentYear - 1],

      // Plant Select2 (POST /Api/StockCoverDayTarget/Select2Plant, scoped + เฉพาะคลังที่ติ๊ก "ใช้งาน SCVD" — F6)
      plantOptions: {
        placeholder: "เลือก Plant",
        allowClear: true,
        ajax: {
          url: "/Api/StockCoverDayTarget/Select2Plant",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function (params) {
            return JSON.stringify({
              plantId: [],
              search: params.term || "",
              page: params.page || 1,
            });
          },
          processResults: function (data) {
            return {
              results: data.results,
              pagination: { more: data.more },
            };
          },
          transport: authTransport,
        },
        language: {
          noResults: function () {
            return "ไม่พบข้อมูล Plant";
          },
        },
      },

      // Product Select2 (GET /Api/Product/Select2Product?productGroupId=14&productTypeId=22)
      productOptions: {
        placeholder: "เลือกสินค้า",
        allowClear: true,
        ajax: {
          url: "/Api/Product/Select2Product",
          delay: 300,
          data: function (params) {
            return {
              productGroupId: 14,
              productTypeId: 22,
              onlyStockCoverDays: true, // CR-StockCoverDays A3: เฉพาะ SKU ที่เปิดใช้งาน SCVD
              search: params.term || "",
              page: params.page || 1,
            };
          },
          processResults: function (data) {
            return {
              results: data.results,
              pagination: { more: data.more },
            };
          },
          transport: authTransport,
        },
        language: {
          noResults: function () {
            return "ไม่พบข้อมูลสินค้า";
          },
        },
      },
    };
  },
  created: function () {
    // QA BUG-12: หน้าเพิ่มข้อมูลเฉพาะสิทธิ์เขียน SCVD (Admin + Team · เงื่อนไขเดียวกับปุ่ม "เพิ่มข้อมูลตามเป้าหมาย" หน้า List)
    // Viewer เปิด URL ตรง → หน้า Unauthorized (route meta ยังรวม SCVD_VIEWER เพื่อไม่กระทบ identity-role gate เดิม)
    if (!this.$root.canShow([["SCVD_ADMIN", "COMPANY_PROFILE_TYPE_SCVD"], ["SCVD_TEAM_EDIT", "COMPANY_PROFILE_TYPE_SCVD"]])) {
      this.$router.replace({ path: "/Error/Unauthorized" });
      return;
    }
    // เริ่มต้นด้วย 1 แถวว่าง
    this.rows = [this.buildRow()];
  },
  mounted: function () {
    // jQuery validate on the form ref (THAI messages via data-msg-required attributes)
    if (this.$refs.scvdForm) {
      $(this.$refs.scvdForm).validate({
        errorElement: "span",
        errorClass: "text-danger",
        highlight: function (element) {
          $(element).addClass("is-invalid");
        },
        unhighlight: function (element) {
          $(element).removeClass("is-invalid");
        },
      });
    }
  },
  methods: {
    goBack: function () {
      this.$router.push("/StockCoverDays/List");
    },

    buildRow: function () {
      this.uidCounter++;
      return {
        _uid: this.uidCounter,
        _hasError: false,
        month: "",
        year: this.currentYear, // default = current year (no backdating)
        saleDays: "", // QA BUG-08: ไม่มีค่าเริ่มต้น — ผู้ใช้ต้องกรอกเอง (อยากได้ 0 ต้องพิมพ์ 0)
        plantCode: "",
        plantName: "",
        productCode: "",
        productName: "",
        bgStock: "",
        bgStockText: "",
        demand: "",
        demandText: "",
        supply: "",
        supplyText: "",
        scvd: null,
      };
    },

    addRow: function () {
      this.rows.push(this.buildRow());
    },

    removeRow: function (index) {
      var self = this;
      Swal.fire({
        title: "ยืนยันการลบ",
        text: "คุณต้องการลบรายการนี้หรือไม่?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "ใช่, ลบ",
        cancelButtonText: "ยกเลิก",
      }).then(function (result) {
        if (result.value) {
          self.rows.splice(index, 1);
        }
      });
    },

    findRow: function (uid) {
      for (var i = 0; i < this.rows.length; i++) {
        if (this.rows[i]._uid === uid) return this.rows[i];
      }
      return null;
    },

    // Plant selected → set code + auto-fill name from option text (A3)
    onPlantChange: function (id, value, data, uid) {
      var row = this.findRow(uid);
      if (!row) return;
      if (data && data.length && data[0].id) {
        row.plantCode = data[0].id;
        row.plantName = data[0].text || "";
      } else {
        row.plantCode = "";
        row.plantName = "";
      }
    },

    // Product selected → set code + auto-fill name from option text (A3)
    onProductChange: function (id, value, data, uid) {
      var row = this.findRow(uid);
      if (!row) return;
      if (data && data.length && data[0].id) {
        row.productCode = data[0].id;
        row.productName = data[0].text || "";
      } else {
        row.productCode = "";
        row.productName = "";
      }
    },

    // Integer-only keydown filter (no decimal, no minus)
    onIntKeydown: function (event) {
      var allowedKeys = [
        "Backspace", "Delete", "Tab", "Escape", "Enter", "Home", "End",
        "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown",
      ];
      if (allowedKeys.indexOf(event.key) !== -1) return;
      if (
        (event.ctrlKey || event.metaKey) &&
        ["a", "c", "v", "x"].indexOf(event.key.toLowerCase()) !== -1
      ) {
        return;
      }
      if (/^[0-9]$/.test(event.key)) return;
      event.preventDefault();
      // QA BUG-09/10/11: ไม่รับตัวอักษร/ค่าติดลบ — ค่าในช่องไม่เปลี่ยน แต่แจ้งผู้ใช้ (เดิมตัดทิ้งเงียบ ๆ)
      if (event.key && event.key.length === 1) {
        this.warnInvalidKey(event.key === "-" ? "ไม่รับค่าติดลบ กรุณากรอกตัวเลข 0 ขึ้นไป" : "กรุณากรอกเฉพาะตัวเลข");
      }
    },
    warnInvalidKey: function (message) {
      Swal.fire({
        toast: true,
        position: "top-end",
        type: "warning",
        title: message,
        showConfirmButton: false,
        timer: 2500,
      });
    },

    onSaleDaysBlur: function (row, event) {
      var raw = (event.target.value || "").trim();
      // QA BUG-08/09/10: ช่องว่างคงว่าง (บังคับกรอกตอนบันทึก) · ค่าผิด (วางข้อความ/ติดลบ/เกิน 31) → แจ้งและล้างช่อง
      // ไม่แปลงค่าเองเงียบ ๆ
      if (raw === "") {
        row.saleDays = "";
      } else if (!/^\d+$/.test(raw)) {
        Swal.fire("ข้อมูลไม่ถูกต้อง", "จำนวนวันขายต้องเป็นตัวเลขจำนวนเต็มระหว่าง 0 ถึง 31", "warning");
        row.saleDays = "";
      } else if (parseInt(raw, 10) > 31) {
        Swal.fire("ข้อมูลไม่ถูกต้อง", "จำนวนวันขายต้องอยู่ระหว่าง 0 ถึง 31", "warning");
        row.saleDays = "";
      } else {
        row.saleDays = parseInt(raw, 10);
      }
      this.computeScvd(row);
    },

    // BG / Demand / Supply — reuse the project's en-US thousands format (mirror Detail.vue formatInt).
    // Source of truth = numeric row[field]; row[field+'Text'] is the formatted display twin.
    formatThousands: function (v) {
      if (v === "" || v === null || v === undefined) return "";
      var n = parseInt(String(v).replace(/,/g, ""), 10);
      if (isNaN(n)) return "";
      return n.toLocaleString("en-US");
    },
    stripThousands: function (v) {
      return String(v === null || v === undefined ? "" : v).replace(/,/g, "");
    },
    // focus → strip formatting back to a plain number for editing
    onNumFocus: function (row, field) {
      row[field + "Text"] = this.stripThousands(row[field + "Text"]);
    },
    // blur → parse, clamp >= 0, store numeric + formatted display, recompute SCVD
    onNumBlur: function (row, field) {
      var raw = this.stripThousands(row[field + "Text"]).trim();
      // QA BUG-08/11: ช่องว่างคงว่าง (บังคับกรอกตอนบันทึก) · ค่าผิด (วางข้อความ/ติดลบ) → แจ้งและล้างช่อง ไม่แปลงเอง
      if (raw !== "" && !/^\d+$/.test(raw)) {
        Swal.fire("ข้อมูลไม่ถูกต้อง", "กรุณากรอกเฉพาะตัวเลขจำนวนเต็ม 0 ขึ้นไป", "warning");
        raw = "";
      }
      var v = raw === "" ? "" : parseInt(raw, 10);
      row[field] = v;
      row[field + "Text"] = this.formatThousands(v);
      this.computeScvd(row);
    },

    // Live JS mirror of ScvdCalculator (F6): SaleDays==0 || Demand==0 → null; else round half-up 2dp
    computeScvd: function (row) {
      var s = parseInt(row.saleDays, 10) || 0;
      var d = parseInt(row.demand, 10) || 0;
      var bg = parseInt(row.bgStock, 10) || 0;
      if (s === 0 || d === 0) {
        row.scvd = null;
        return;
      }
      var raw = (bg * s) / d;
      // half-up (values are non-negative → Math.round rounds .5 up = AwayFromZero)
      row.scvd = Math.round(raw * 100) / 100;
    },

    formatScvd: function (value) {
      if (value === null || value === undefined) return "-";
      return Number(value).toFixed(2);
    },

    // IssueList #23: true if ANY (plant, year, product) group among the grid rows covers fewer than
    // 12 distinct months. Mirrors the backend group key (Plant×Product×Year). Rows missing a key part
    // are skipped — onSubmit's per-row required checks already blocked those before the confirm runs.
    hasIncompleteMonthGroup: function () {
      var groups = {};
      for (var i = 0; i < this.rows.length; i++) {
        var r = this.rows[i];
        if (!r.plantCode || !r.productCode || !r.year || !r.month) continue;
        var key = r.plantCode + "|" + r.year + "|" + r.productCode;
        if (!groups[key]) groups[key] = {};
        groups[key][r.month] = true;
      }
      for (var k in groups) {
        if (Object.prototype.hasOwnProperty.call(groups, k)) {
          if (Object.keys(groups[k]).length < 12) return true;
        }
      }
      return false;
    },

    onSubmit: async function () {
      var self = this;

      // reset previous row-error highlights
      self.rows.forEach(function (r) {
        r._hasError = false;
      });

      // jQuery validate (native selects/inputs: month/year/saleDays)
      if (self.$refs.scvdForm && !$(self.$refs.scvdForm).valid()) {
        // QA BUG-08: แจ้งเตือนรวม + ข้อความสีแดงใต้ช่องที่ขาด (jQuery validate)
        Swal.fire("ข้อมูลไม่ครบ", "กรุณากรอกข้อมูลในช่องที่มีเครื่องหมาย * ให้ครบ (ดูข้อความสีแดงใต้ช่องที่ยังไม่ได้กรอก)", "warning");
        return;
      }

      if (self.rows.length === 0) {
        Swal.fire("ข้อมูลไม่ครบ", "กรุณาเพิ่มอย่างน้อย 1 รายการ", "warning");
        return;
      }

      // Per-row required checks (Plant/Product Select2 are hidden → not covered by jQuery validate)
      for (var i = 0; i < self.rows.length; i++) {
        var r = self.rows[i];
        var n = i + 1;
        if (!r.month) {
          r._hasError = true;
          Swal.fire("ข้อมูลไม่ครบ", "กรุณาเลือกเดือนในแถวที่ " + n, "warning");
          return;
        }
        if (!r.year) {
          r._hasError = true;
          Swal.fire("ข้อมูลไม่ครบ", "กรุณาเลือกปีในแถวที่ " + n, "warning");
          return;
        }
        if (!r.plantCode) {
          r._hasError = true;
          Swal.fire("ข้อมูลไม่ครบ", "กรุณาเลือกคลังสินค้าในแถวที่ " + n, "warning");
          return;
        }
        if (!r.productCode) {
          r._hasError = true;
          Swal.fire("ข้อมูลไม่ครบ", "กรุณาเลือกสินค้าในแถวที่ " + n, "warning");
          return;
        }
        // QA BUG-08: 4 ช่องบังคับกรอก (ไม่มีค่าเริ่มต้นแล้ว) — ว่าง → แจ้ง + ไฮไลต์แถวสีแดง
        if (r.saleDays === "" || r.saleDays === null || r.saleDays === undefined) {
          r._hasError = true;
          Swal.fire("ข้อมูลไม่ครบ", "กรุณากรอกจำนวนวันขายในแถวที่ " + n, "warning");
          return;
        }
        var reqNums = [["bgStock", "จำนวน BG Stock"], ["demand", "จำนวน Demand"], ["supply", "จำนวน Supply"]];
        for (var q = 0; q < reqNums.length; q++) {
          var fv = r[reqNums[q][0]];
          if (fv === "" || fv === null || fv === undefined) {
            r._hasError = true;
            Swal.fire("ข้อมูลไม่ครบ", "กรุณากรอก" + reqNums[q][1] + "ในแถวที่ " + n, "warning");
            return;
          }
        }
        var sd = parseInt(r.saleDays, 10);
        if (isNaN(sd) || sd < 0 || sd > 31) {
          r._hasError = true;
          Swal.fire("ข้อมูลไม่ถูกต้อง", "จำนวนวันขายในแถวที่ " + n + " ต้องอยู่ระหว่าง 0 ถึง 31", "warning");
          return;
        }
      }

      // R2-19: หน้า Create ใช้ modal เดียวให้ตรงกับหน้า Detail/Edit — ไม่เด้ง modal เตือน "เดือนไม่ครบ" แยก
      // ก่อนอีกต่อไป. การเตือน version n (needVersionConfirm) มาจาก BE (ดู doSave) และข้อความ carry-forward
      // เดือนที่เหลือ (IssueList #23: version = snapshot 12 เดือน · BE เติมเดือนที่ขาดจาก version ล่าสุด) จะถูก
      // "ต่อท้าย" modal version นั้นแทน เมื่อกรอกไม่ครบ → เหลือ pop-up เดียวในทุกกรณีที่เป็นข้อมูลซ้ำ.

      // Build flat rows in the StockCoverDayTargetImportRow shape (Scvd recomputed server-side).
      var rows = self.rows.map(function (r, idx) {
        return {
          RowNumber: idx + 1,
          Month: parseInt(r.month, 10),
          Year: parseInt(r.year, 10),
          SaleDays: parseInt(r.saleDays, 10) || 0,
          PlantCode: r.plantCode,
          PlantName: r.plantName,
          ProductCode: r.productCode,
          ProductName: r.productName,
          BGStockLitre: parseInt(r.bgStock, 10) || 0,
          DemandLitre: parseInt(r.demand, 10) || 0,
          SupplyLitre: parseInt(r.supply, 10) || 0,
        };
      });

      await self.doSave(rows, false);
    },

    // Feed flat rows through the EXISTING Import-confirm pipeline (re-validate + C1 + versioning + write).
    // R2-19: two-phase — ส่ง confirmNewVersion=false ก่อน; ถ้า BE ตอบ needVersionConfirm (มี (คลัง+สินค้า+ปี)
    // ที่มีข้อมูลเดิม → จะบันทึกเป็นเวอร์ชันใหม่) แสดงข้อความจาก BE (pattern เดียวกับหน้า Detail/Edit ระบุเลข
    // เวอร์ชันที่จะบันทึก) แล้วส่งซ้ำด้วย confirmNewVersion=true เพื่อเขียนจริง.
    doSave: async function (rows, confirmNewVersion) {
      var self = this;
      try {
        self.isSaving = true;
        KTApp.blockPage({ opacity: 0.05, message: "กำลังบันทึกข้อมูล..." });

        var response = await axios.post(
          "/Api/StockCoverDayTarget/ImportConfirm",
          { rows: rows, confirmNewVersion: !!confirmNewVersion },
          {
            headers: {
              Authorization: "Bearer " + self.$root.user.access_token,
            },
          }
        );

        KTApp.unblockPage();
        self.isSaving = false;

        var data = response.data || {};

        // R2-19: มีข้อมูลเดิม → BE ขอยืนยันสร้างเวอร์ชันใหม่ (ข้อความ pattern เดียวกับหน้า Detail/Edit)
        if (data.needVersionConfirm && !confirmNewVersion) {
          // IssueList #23: ถ้ากรอกไม่ครบ 12 เดือน → BE เติมเดือนที่ขาดจาก Version ล่าสุด (carry-forward)
          // ต่อท้าย modal version นี้ (ไม่เด้ง pop-up แยก) เพื่อให้เหลือ modal เดียวเหมือนหน้า Edit
          var carryWarn = self.hasIncompleteMonthGroup()
            ? "<br><br>ℹ️ บางเดือนไม่ได้กรอกข้อมูล — ระบบจะใช้ข้อมูลเดือนที่เหลือจาก Version ล่าสุด (ถ้ามี)"
            : "";
          // P5: การบันทึกปีปัจจุบันจะ re-calculate snapshot ของเดือนที่ปิดรอบแล้วในปีนี้
          var reCalcWarn = self.rows.some(function (r) { return parseInt(r.year, 10) === self.currentYear; })
            ? "<br><br><b style='color:#b45309'>⚠️ ปีปัจจุบัน:</b> การบันทึกจะ<b>คำนวณ snapshot ของเดือนที่ปิดรอบแล้ว</b>ในปีนี้ใหม่ (re-calculate) โดยอัตโนมัติ"
            : "";
          var vConfirm = await Swal.fire({
            title: "พบข้อมูลเดิม",
            html: (data.message || "พบข้อมูลของสินค้านี้อยู่แล้ว ต้องการเพิ่มเป็น Version ใหม่ใช่หรือไม่?") + carryWarn + reCalcWarn,
            type: "question",
            showCancelButton: true,
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ย้อนกลับแก้ไข",
          });
          if (vConfirm.value) {
            await self.doSave(rows, true);
          }
          return;
        }

        if (data.success) {
          // R2-23: สรุปข้อมูลที่บันทึก แยกราย plant + จำนวนสินค้า
          var summary = self.buildImportSummary(rows);
          await Swal.fire({
            title: "บันทึกสำเร็จ",
            html: "บันทึกข้อมูล Stock Cover Days เรียบร้อยแล้ว"
              + (summary.length ? "<br><br><div style='text-align:left;display:inline-block'>" + summary.join("<br>") + "</div>" : ""),
            type: "success",
          });
          self.$router.push({
            path: "/StockCoverDays/List",
            query: { reload: Date.now() },
          });
        } else {
          // ASSUMPTION: /ImportConfirm returns a single message string (first failing row), not a
          // per-row error array. Best-effort: parse "แถวที่ N" to highlight the offending grid row.
          self.highlightErrorRow(data.message);
          Swal.fire("เกิดข้อผิดพลาด", data.message || "ไม่สามารถบันทึกข้อมูลได้", "error");
        }
      } catch (error) {
        KTApp.unblockPage();
        self.isSaving = false;
        var message = "ไม่สามารถบันทึกข้อมูลได้";
        if (error.response && error.response.data && error.response.data.message) {
          message = error.response.data.message;
        }
        if (error.response && error.response.status === 403) {
          message = "คุณไม่มีสิทธิ์บันทึกข้อมูล กรุณาติดต่อผู้ดูแลระบบ"; // QA BUG-05
        }
        self.highlightErrorRow(message);
        Swal.fire("เกิดข้อผิดพลาด", message, "error");
      }
    },

    // Best-effort: mark the grid row referenced by a server "แถวที่ N" message so the user can find it.
    highlightErrorRow: function (message) {
      if (!message) return;
      var m = String(message).match(/แถวที่\s*(\d+)/);
      if (m) {
        var idx = parseInt(m[1], 10) - 1;
        if (idx >= 0 && idx < this.rows.length) {
          this.rows[idx]._hasError = true;
        }
      }
    },
    // R2-23: สรุป rows ที่ import/บันทึก → รายการ "N.[plant] ชื่อคลัง X สินค้า" ต่อ plant (distinct product)
    // รองรับ key ทั้ง PascalCase (rows ที่สร้างฝั่ง client) และ camelCase (importRows จาก BE)
    buildImportSummary: function (rows) {
      var groups = {};
      var order = [];
      (rows || []).forEach(function (r) {
        var pc = r.PlantCode != null ? r.PlantCode : r.plantCode;
        var pn = r.PlantName != null ? r.PlantName : r.plantName;
        var prod = r.ProductCode != null ? r.ProductCode : r.productCode;
        if (!pc) return;
        if (!groups[pc]) { groups[pc] = { name: pn || "", products: {} }; order.push(pc); }
        if (prod != null && prod !== "") groups[pc].products[prod] = true;
      });
      return order.map(function (pc, i) {
        var g = groups[pc];
        var cnt = Object.keys(g.products).length;
        return (i + 1) + ".[" + pc + "] " + (g.name || "") + " " + cnt + " สินค้า";
      });
    },

    // ── Import (ตาม wireframe §1.2 / §1.3) — validate → preview → confirm → เขียน DB ──
    downloadTemplate: function () {
      let self = this;
      KTApp.blockPage({ opacity: 0.05, message: "กำลังสร้าง Template กรุณารอสักครู่..." });
      axios
        .get("/Api/StockCoverDayTarget/DownloadTemplate", {
          responseType: "blob",
          headers: { Authorization: "Bearer " + self.$root.user.access_token },
        })
        .then(function (response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          var dTpl = new Date();
          var datePrefixTpl = dTpl.getFullYear() + "-" + ("0" + (dTpl.getMonth() + 1)).slice(-2) + "-" + ("0" + dTpl.getDate()).slice(-2);
          link.setAttribute("download", datePrefixTpl + "_StockCoverDays_Import_Template.xlsx");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch(function () {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถดาวน์โหลด Template ได้", "error");
        })
        .then(function () {
          KTApp.unblockPage();
        });
    },
    showImportModal: function () {
      this.resetImportForm();
      $("#importStockCoverDaysModal").modal("show");
    },
    resetImportForm: function () {
      this.importFile = null;
      this.importFileName = "";
      if (this.$refs.importFileInput) {
        this.$refs.importFileInput.value = "";
      }
    },
    onFileChange: function (e) {
      const file = e.target.files[0];
      if (file) {
        const ext = file.name.split(".").pop().toLowerCase();
        if (ext !== "xlsx") {
          Swal.fire("ผิดพลาด", "กรุณาเลือกไฟล์ .xlsx เท่านั้น", "error");
          this.$refs.importFileInput.value = "";
          this.importFile = null;
          this.importFileName = "";
          return;
        }
        this.importFile = file;
        this.importFileName = file.name;
      } else {
        this.importFile = null;
        this.importFileName = "";
      }
    },
    // Step 1 — validate + preview (no DB write)
    submitImport: function () {
      if (!this.importFile) {
        Swal.fire("ผิดพลาด", "กรุณาเลือกไฟล์ Excel", "warning");
        return;
      }
      let self = this;
      const formData = new FormData();
      formData.append("file", this.importFile);
      KTApp.blockPage({ opacity: 0.05, message: "กำลังตรวจสอบข้อมูล กรุณารอสักครู่..." });
      axios
        .post("/Api/StockCoverDayTarget/Import", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(function (response) {
          if (response.data.success) {
            $("#importStockCoverDaysModal").modal("hide");
            const preview = response.data.preview || {};
            const rows = response.data.importRows || [];
            let html = `<p>ตรวจสอบข้อมูลสำเร็จ พร้อมนำเข้า</p>`;
            html += `<p>- จำนวนแถวทั้งหมด: ${preview.totalRows || 0} รายการ<br/>`;
            html += `- กลุ่มที่เพิ่มใหม่ (Version 1): ${preview.newGroupCount || 0} กลุ่ม<br/>`;
            html += `- กลุ่มที่มีอยู่แล้ว (สร้าง Version ใหม่): ${preview.existingGroupCount || 0} กลุ่ม</p>`;
            // P5: importing any row for the CURRENT year re-calculates snapshots of already-closed months of this year.
            if (rows.some((r) => parseInt(r.year != null ? r.year : r.Year, 10) === self.currentYear)) {
              html += "<br><br><b style='color:#b45309'>⚠️ ปีปัจจุบัน:</b> การบันทึกจะ<b>คำนวณ snapshot ของเดือนที่ปิดรอบแล้ว</b>ในปีนี้ใหม่ (re-calculate) โดยอัตโนมัติ";
            }
            Swal.fire({
              title: "ยืนยันการนำเข้าข้อมูล",
              html: html,
              type: "info",
              showCancelButton: true,
              confirmButtonText: "ยืนยันนำเข้า",
              cancelButtonText: "ยกเลิก",
              showLoaderOnConfirm: true,
            }).then((result) => {
              if (result.value) {
                self.confirmImport(rows);
              }
            });
          } else {
            self.lastImportRows = response.data.importRows || null;
            let errorHtml = `<p>${response.data.message || "นำเข้าข้อมูลไม่สำเร็จ"}</p>`;
            if (self.lastImportRows && self.lastImportRows.length > 0) {
              errorHtml += `<p>คลิก <strong>ดาวน์โหลด Error Detail</strong> เพื่อดูรายละเอียด</p>`;
            }
            Swal.fire({
              title: "นำเข้าข้อมูลไม่สำเร็จ",
              html: errorHtml,
              type: "error",
              showCancelButton: self.lastImportRows && self.lastImportRows.length > 0,
              confirmButtonText: "ตกลง",
              cancelButtonText: '<i class="fas fa-download"></i> ดาวน์โหลด Error Detail',
              cancelButtonColor: "#5867dd",
            }).then((result) => {
              if (result.dismiss === Swal.DismissReason.cancel) {
                self.downloadErrorDetail();
              }
            });
          }
        })
        .catch(function (error) {
          var message = "เกิดข้อผิดพลาดในการนำเข้าข้อมูล";
          if (error.response && error.response.data && error.response.data.message) {
            message = error.response.data.message;
          }
          Swal.fire("เกิดข้อผิดพลาด", message, "error");
        })
        .then(function () {
          KTApp.unblockPage();
        });
    },
    // Step 2 — commit validated rows → กลับหน้า List เพื่อดูข้อมูลที่นำเข้า
    // R2-19: flow นำเข้า Excel มี dialog ยืนยันของตัวเองอยู่แล้ว (แสดงจำนวน "กลุ่มที่มีอยู่แล้ว (สร้าง Version ใหม่)"
    // + คำเตือน re-calculate ปีปัจจุบัน) ผู้ใช้ยืนยันไปแล้วในขั้นตอนนั้น → ส่ง confirmNewVersion=true เพื่อข้าม
    // version-confirm gate (ไม่ถามซ้ำ). การเตือนเวอร์ชัน n ผ่าน needVersionConfirm ใช้กับ flow กรอกมือ (doSave).
    confirmImport: function (rows) {
      let self = this;
      KTApp.blockPage({ opacity: 0.05, message: "กำลังนำเข้าข้อมูล กรุณารอสักครู่..." });
      axios
        .post("/Api/StockCoverDayTarget/ImportConfirm", { rows: rows, confirmNewVersion: true })
        .then(function (response) {
          if (response.data.success) {
            // R2-23: สรุปข้อมูลที่นำเข้า แยกราย plant + จำนวนสินค้า
            var summary = self.buildImportSummary(rows);
            // R2-31: นับ "รายการ" เป็นจำนวนโรงงาน ให้ตรงกับรายการสรุปด้านล่าง
            Swal.fire({
              title: "สำเร็จ",
              html: `นำเข้าข้อมูลสำเร็จ ${summary.length || response.data.createdCount || 0} รายการ`
                + (summary.length ? "<br><br><div style='text-align:left;display:inline-block'>" + summary.join("<br>") + "</div>" : ""),
              type: "success",
            }).then(function () {
              self.$router.push({ path: "/StockCoverDays/List", query: { reload: Date.now() } });
            });
          } else {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }
        })
        .catch(function (error) {
          var message = "เกิดข้อผิดพลาดในการนำเข้าข้อมูล";
          if (error.response && error.response.data && error.response.data.message) {
            message = error.response.data.message;
          }
          Swal.fire("เกิดข้อผิดพลาด", message, "error");
        })
        .then(function () {
          KTApp.unblockPage();
        });
    },
    downloadErrorDetail: function () {
      if (!this.lastImportRows || this.lastImportRows.length === 0) {
        Swal.fire("ผิดพลาด", "ไม่พบข้อมูลสำหรับ export", "warning");
        return;
      }
      KTApp.blockPage({ opacity: 0.05, message: "กำลังสร้างไฟล์ กรุณารอสักครู่..." });
      axios
        .post(
          "/Api/StockCoverDayTarget/ExportErrors",
          { importRows: this.lastImportRows },
          { responseType: "blob" }
        )
        .then(function (response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          const contentDisposition = response.headers["content-disposition"];
          var dErr = new Date();
          var datePrefixErr = dErr.getFullYear() + "-" + ("0" + (dErr.getMonth() + 1)).slice(-2) + "-" + ("0" + dErr.getDate()).slice(-2);
          let filename = datePrefixErr + "_StockCoverDays_ImportErrors.xlsx";
          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (filenameMatch && filenameMatch[1]) {
              filename = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ""));
            }
          }
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch(function (error) {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถดาวน์โหลดไฟล์ได้", "error");
        })
        .then(function () {
          KTApp.unblockPage();
        });
    },
  },
};
</script>

<style scoped>
.readonly-field {
  background-color: #e9ecef !important;
  cursor: not-allowed;
}
.table-sm td,
.table-sm th {
  padding: 0.35rem;
  vertical-align: middle;
}
/* keep the flat grid usable on narrow viewports without wrapping select2/inputs */
.scvd-flat-grid {
  min-width: 1200px;
}
</style>



// WEBPACK FOOTER //
// App/Components/StockCoverDays/StockCoverDaysCreate.vue